import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoClose } from 'react-icons/io5';

const ImportantInfoModal = ({ isOpen, onClose }) => {
  const infoSections = [
    {
      title: "Order Process",
      content: `Fill the form on the selected car's page by complete all the neccessary fields and then by clicking the "RENT NOW" button. After that you need to confirm your order by see and confirm your booking details. Finally you click "PLACE ORDER" button and your booking has been submited.

As soon as we receive your order, Luxury Yacht Mykonos will accept it or not depending on the availability. This is the reason why making your reservation some time in advance is important, especially during the peak season of July-August. In order a reservation to take effect.

An automatic confirmation email for the reservation with details on the delivery of the vehicle will be sent to you via e-mail, so make sure that the e-mail address you provide is correct!

In case Luxury Yacht Mykonos cannot confirm your order for any reason a cancellation e-mail will be sent to you with suggestions on changing your order.

It is essential that you provide a correct e-mail address and mobile phone number in order to contact you for your car booking.`
    },
    {
      title: "Fixed Rates - No booking fees",
      content: "No hidden fees"
    },
    {
      title: "Out of hour charges",
      content: `The possibility of getting a vehicle OUT of normal working hours (20:00 to 09:00) exists in most locations; however, an additional charge of 20,00€ (incl. VAT) for "out of working hours" service may apply.

During the booking procedure, you will be able to see the details. In case the vehicle pick-up to falls outside normal working hours due to a flight/ ferry delay or for any other reason, the additional fee is charged locally, where the "out of working hours" service is available.`
    },
    {
      title: "Modifications",
      content: "In order to make a modification, you have to contact us for approval. Any modification should be made at least 5 days prior to delivery."
    },
    {
      title: "Fuel",
      content: "Fuel is NOT included in the rates. Vehicles should be returned with the same fuel level as the one when the vehicle was delivered. Same (delivery) to same (collection) fuel level."
    },
    {
      title: "Qonsequential Loss",
      content: "Luxury Yacht Mykonos is not liable for any indirect losses that happen as a side-effect of the main loss or damage, which could not have been foreseen by the client and Luxury Yacht Mykonos (such as loss of profits or loss of opportunity)."
    },
    {
      title: "Force Majeure",
      content: "Luxury Yacht Mykonos is not liable for either a failure to perform or delay in performing any of its obligations under this booking agreement in case a performance is delayed, hindered or prevented due to force majeure, meaning any event beyond the reasonable control of Luxury Yacht Mykonos such as natural disasters etc."
    },
    {
      title: "Special Requests",
      content: `Child / Baby seats / Boosters:

Any Child/Baby/Booster seat will be charged 5,00€ (incl. VAT), daily on request. Due to insurance rules you are required to fit the child/baby/booster seat yourself.

Across border rentals: Not allowed.

If you intend to move the rental vehicle outside Mykonos you should seek permission from Luxury Yacht Mykonos company.

You should always inform the car rental company before taking a vehicle on a ferry. If the vehicle is ferried without permission from Luxury Yacht Mykonos, no insurance coverage is applied for any damages incurred in the vehicle or on 3rd party.

Additional drivers: An (one) additional driver is free of charge. A third (3rd) additionaldriver is available with an extra cost of 7,00€ per day.`
    },
    {
      title: "Liability",
      content: `Luxury Yacht Mykonos assumes no liability for actual rentals that do not take place due to reasons for which the hirer is responsible.

Such reasons are for example:

failure to present a driver's license or presenting a driver's license which is no longer valid.
failure to present a valid passport or identification card.
failure to present a valid credit card.
non-compliance to the regulations regarding the minimum or maximum age.`
    },
    {
      title: "Mileage / Kilometers",
      content: "Your rental includes an unlimited number of free miles."
    },
    {
      title: "Age requirements",
      content: "The minimum rental age for this car is 21 years."
    },
    {
      title: "Driver's License",
      content: `Drivers are required to provide a full driving license held for at least three (3) years. Additionally, a valid passport or ID card has to be presented at the pick-up of the vehicle.

It is the driver's responsibility to ensure that he/she has the appropriate driving license; no refund is given for rentals rejected due to non-show of a valid driving license. Facsimiles/photocopies or pictures of driving licenses are NOT acceptable.`
    },
    {
      title: "Payment methods",
      content: "Pay on car delivery via cash or credit/debit card. No upfront payment needed!"
    },
    {
      title: "Cancellation Fees",
      content: "Car rental cancellation fees are free up to two weeks prior to the rental date. If a cancellation occurs within the two weeks leading up to the rental date, you may lose your reservation guarantee fee."
    }
  ];

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4 JosefinSans"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          onClick={e => e.stopPropagation()}
          className="bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-[90vh] overflow-hidden relative"
        >
          {/* Header */}
          <div className="sticky top-0 bg-white z-10 px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <h2 className="text-2xl font-bold text-gray-800">Important Information for Mykonos Luxury Yachts</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <IoClose size={24} />
            </button>
          </div>

          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(90vh-80px)] p-6">
            <div className="space-y-8">
              {infoSections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className={`flex flex-col md:flex-row gap-6 ${
                    index !== infoSections.length - 1 ? 'pb-8 border-b border-gray-200' : ''
                  }`}
                >
                  <div className="md:w-1/3">
                    <h3 className="text-lg font-semibold text-blue-900">{section.title}</h3>
                  </div>
                  <div className="md:w-2/3">
                    <div className="text-gray-600 whitespace-pre-line">{section.content}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ImportantInfoModal;